// element argument can be a selector string
//   for an individual element

console.log(window.screen.width);
var flkty = new Flickity( '.flickity-carousel ', {
  groupCells: window.screen.width <= 768 ? 2 : 4,
  cellAlign: 'left',
  contain: true
});

window.onscroll = function() {myFunction()};

var header = document.getElementById("SiteHeader");
var wrapper = document.getElementsByClassName("header-sticky-wrapper");
console.log(wrapper);
var sticky = wrapper[0].offsetTop;

function myFunction() {
  console.log(window.pageYOffset, sticky)
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}